import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, Core2Config, Pagination, PagingResponseModel} from '../../shared';
import {EntityLoginSubjectLinkContainerModel} from '../../../../../../models/aggregates/erp/entity';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class EntityLoginSubjectLinkService extends BaseApiPublicLoginTemplateService<EntityLoginSubjectLinkContainerModel, EntityLoginSubjectLinkContainerModel, EntityLoginSubjectLinkContainerModel> {
  
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-login-subject-links';
  static readonly ENTITY_LOGIN_SUBJECT_SUB_PATH = '/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-login-subject-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-login-subject-links';
    this.httpClient = http;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-login-subject-links' + EntityLoginSubjectLinkService.ENTITY_LOGIN_SUBJECT_SUB_PATH + BaseApiPublicLoginTemplateService.LOGIN_ENTITY_EP;
  }

  getOwnEntitySubjectLink(visa: ApiVisa): Observable<ApiResponseModel<EntityLoginSubjectLinkContainerModel>> {
    const loginApiUrl = this.endpoint_path_login_entity_url && visa.api_domain_url ?
      visa.api_domain_url + this.endpoint_path_login_entity_url
      : this.apiUrl;

    return this.httpClient.get<ApiResponseModel<EntityLoginSubjectLinkContainerModel>>(
      loginApiUrl, this.getHttpHeader(visa)
    )
  }

  public getByCriteriaPromiseLoginEP(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Promise<PagingResponseModel<EntityLoginSubjectLinkContainerModel>> {
    if (this.endpoint_path_login_entity_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_entity_url;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<EntityLoginSubjectLinkContainerModel>>(UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }
}
